module.exports = __webpack_public_path__ + "assets/img/jtfx57.baa330db.jpg";